import { ContentList } from "./ContentList/ContentList";
import { WeatherDetails } from "./styles";

export function WeatherInfos() {
  return (
    <WeatherDetails>
      <ContentList />
    </WeatherDetails>
  );
}
